import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import { install as I18nVuePlugin } from '@/i18n';
import { rem, initReport, user  } from '@tencent/ppd-base-libs';
import { aegis, addBiToESIntercept } from '@tencent/wphk-base-report';
import { plugin } from '@tencent/fit-bi-sdk';
import MtaConfigGlobal from '@/mta-config-global';
import { createPinia, PiniaVuePlugin } from 'pinia';
import {
  getServerTime,
  setServerTime,
} from '@tencent/wphk-components-common/utils/server-time';
import { REPORT_WHITE_LIST } from '@/config/bi-to-es-white-list';
// 登录态处理
import '@/business/login';
import { initFontScale } from '@tencent/wphk-components-project-common';
// 大字体缩放初始化处理（解决大字体下页面进入时的闪动问题、监听页面大字体缩放变化，实时写入字体缩放css变量）
initFontScale();

// 设置系统时间
const win: any = window;
const serverTime = win.__$$_serverTimeMills
  ? new Date(win.__$$_serverTimeMills)
  : new Date();
setServerTime(serverTime.getTime());
console.log('读取服务器时间：', getServerTime());

// pinia初始化
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// 测速上报初始化，id传入项目英文名称，如：pay-center、discount-center
aegis.init({ id: process.env.VUE_APP_PKGNAME });

// 添加全局i18n函数
Vue.use(I18nVuePlugin);

// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

// bi工具初始化代码，请注意使用 bi-cli 生成 mta-config-global.ts 后，引入到项目中，并在main.ts中初始化
Vue.use(plugin, {
  ...MtaConfigGlobal,
  route: router,
  beforeReport: item => ({
    ...item,
    params: { ...item.params, fuin: user.getUin(), fopenid: user.getUin() },
  }),
});

addBiToESIntercept(REPORT_WHITE_LIST);

// 初始化上报
initReport(
  {
    router,
    // @ts-ignore
    appEnv: process.env.VUE_APP_ENV,
    // @ts-ignore
    business: process.env.VUE_APP_PKGNAME, // 区分业务，用于elk
    isReportPageStayedTime: true, // 是否上报页面停留时间
    bi: {
      reportNeedLogin: true,
    },
  },
  Vue,
);

// 开启rem布局
rem();

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.config.errorHandler = function (err) {
  window.AegisV2.error(err);
};

new Vue({
  router,
  render: h => h(App),
  pinia,
}).$mount('#app');

aegis.reportTime('main_ready');
